import { Col, Modal, Row } from "antd";
import { useEffect, useState } from "react";
import LoginBanner from '../../assets/images/login_background.png';
import { useAppDispatch, useAppSelector } from "../../redux/Hooks";
import { toggleForgotPasswordModal } from "../forgot-password/redux/ForgotPasswordSlice";
import { toggleRegisterModal } from "../register/redux/RegisterSlice";
import LoginForm from "./components/LoginForm";
import { toggleLoginModal } from "./redux/LoginSlice";
import { ReactComponent as IconAmber } from '../../assets/images/IconAmber.svg';
import './assets/css/styles.scss';

const LoginModal = () => {
    const [error, setError] = useState(false);
    const [message, setMessage] = useState("");
    const dispatch = useAppDispatch();
    const loginState = useAppSelector(state => state.login);

    useEffect(() => {
        localStorage.removeItem("accessToken")
    }, [])

    const openRegister = () => {
        dispatch(toggleLoginModal());
        dispatch(toggleRegisterModal());
    }

    const openForgotPassword = () => {
        dispatch(toggleLoginModal());
        dispatch(toggleForgotPasswordModal());
    }

    const setErrorStatus = (isError: boolean, errorMessage?: string) => {
        setError(isError);
        setMessage(errorMessage || "");
    }

    return (
        <Modal
            // width={1000}
            style={{ minWidth: 1000 }}
            visible={loginState.modalVisible}
            onCancel={() => dispatch(toggleLoginModal())}
            className="custom-modal"
            footer={false}
            bodyStyle={{ padding: '0px 24px 0px 0px', height: 650 }}
        >
            <Row gutter={50} justify="center" align="middle" style={{ height: '100%' }}>
                <Col span={10}>
                    <img alt="login" src={LoginBanner} style={{ height: 650, borderRadius: '20px 0px 0px 20px', width: '100%', objectFit: 'cover' }} />
                    <div className="login-logo">
                        <IconAmber />
                        <div className="font-size-24" style={{ color: 'white' }}><span className="font-bold">ĐẤU GIÁ</span> TRỰC TUYẾN</div>
                        <span style={{ color: 'white' }}>TRUNG TÂM DỊCH VỤ ĐẤU GIÁ TÀI SẢN</span>
                    </div>
                </Col>
                {/* <Col span={14} style={{ padding: '70px 0px 50px 0px' }}> */}
                <Col span={14} style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <div className="font-size-30" style={{ textAlign: 'center' }}>Đăng nhập</div>
                    <div style={{ visibility: error ? 'visible' : 'hidden', color: '#BB4048', textAlign: 'center' }}>
                        {message.split("\n")?.map(item => <div key={item}>{item.trim()}</div>)}
                    </div>
                    <LoginForm openRegister={openRegister} openForgotPassword={openForgotPassword} setErrorStatus={setErrorStatus} />
                </Col>
            </Row>
        </Modal>
    )
}

export default LoginModal;